export default "__VITE_ASSET__491fe180__"